import type { QueryClient } from '@tanstack/react-query';
import { orpc } from '@/lib/api/orpc';
import { deviceAssignmentAlertKeys } from './alert-query-keys';
const dar = orpc.deviceAssignmentRule;

/** Device Assignment alert Read Model の query key を無効化する。 */
export function invalidateDeviceAssignmentAlerts(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({
    queryKey: deviceAssignmentAlertKeys.all
  });
}

/** Rule 一覧も併せて無効化する（件数バッジ更新用）。 */
export function invalidateDeviceAssignmentRulesAndAlerts(queryClient: QueryClient, ruleId?: string): void {
  void queryClient.invalidateQueries({
    queryKey: dar.list.key()
  });
  if (ruleId != null && ruleId.length > 0) {
    void queryClient.invalidateQueries({
      queryKey: dar.get.key({
        input: {
          ruleId
        }
      })
    });
  }
  invalidateDeviceAssignmentAlerts(queryClient);
}